import React, { Component } from 'react';
import logger from './Logger';
class ErrorBoundaryLoggly extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        logger.push({ error, info });
    }
    render() {
        if (this.state.hasError) {
            return <h1>Something went wrong!</h1>;
        }
        return this.props.children;
    }
}
export default ErrorBoundaryLoggly;